import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";

export default function SectionAboutTestimonial() {
  var settings = {
    arrows: false,
    autoplay: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  return (
    <Slider {...settings}>
     	<div>
      		<i>"We have been working with Ms Majernikova for more than {new Date().getFullYear() - 2017} years with a great satisfaction. We've implemented more than 40 projects together and she did all of them very professionally and always to full satisfaction. We appreciate her flexibility, reliability, speed and quality work. Negotiation is always without any problem and the price is adequate. I'm pleased to recommend Ms.&#160;Majernikova."</i>
        	<div className="about__testimonial-client">Ing. J. Šmigura, CEO, SnugDesign s.r.o.</div>
    	</div>
    	<div>
            <i>"We have been cooperating with Bára for several years. Thanks to the codes, she has provided us with, we were able to finish plenty of interesting projects. What we appreciate the most is her professional attitude to work and her reliability at any time." </i>
            <div className="about__testimonial-client">Team CorporatePRO</div>
        </div>
        <div>
            <i>"We have cooperated with Barbora Majernikova on several projects and there has been always a great satisfaction with her work. Unlike some other front end developers we work with, there is no need to modify the code and fix it in the responsive resolutin. It is always a precisely processed output without any problems and, moreover, always delivered on time." </i>
            <div className="about__testimonial-client">Inizio.cz</div>
        </div>
    </Slider>
  );
}
